module.exports = __webpack_public_path__ + "static/img/cont32_04.43165ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont32_04.jpg
// module id = 3P7i
// module chunks = 0